import { useEffect, useState, Suspense } from "react";

import GlanumLeaflet from "./component/GlanumLeaflet";
import Loader from "./component/Loader";

import "overlayscrollbars/overlayscrollbars.css";
import { filterDistanceCreateDataJson } from "./utils/distanceFilters";

const Container = () => {
  const [dataIsReturned, setDataIsReturned] = useState(false);
  const [json, setJson] = useState(null);
  const [fetchError, setFetchError] = useState(false);

  useEffect(() => {
    let url = "";
    const params = document.getElementById("root").dataset.params || "";

    if (process.env.REACT_APP_DEPLOY === "prod") {
      url = document.getElementById("root").dataset.url;
    } else if (process.env.REACT_APP_DEPLOY === "dev") {
      url = `/local-datas/${process.env.REACT_APP_CLIENT}.json`;
    }
    setTimeout(() => {
      fetch(url + params, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      })
        .then((response) => response.json())
        .then(async (jsonData) => {
          let newDataJson = { ...jsonData }
          if (process.env.REACT_APP_DISTANCE_FILTERS === "true") {
            newDataJson = filterDistanceCreateDataJson(jsonData)
          }
          setJson(newDataJson);
          setDataIsReturned(true);
        })
        .catch((error) => {
          setFetchError(true);
        });
    }, 500);
  }, []);

  if (fetchError) {
    return (
      <>
        <div className="display_error">
          <h2>Oups ! Une erreur est survenue.</h2>
        </div>
      </>
    );
  }

  if (!dataIsReturned) {
    return (
      <>
        <Loader />
      </>
    );
  } else if (json) {
    if (json?.entities) {
      return <GlanumLeaflet data={json} />;
    } else {
      return (
        <>
          <div className="display_error">
            <h2>Oups ! Une erreur est survenue.</h2>
          </div>
        </>
      );
    }
  }
};

export default Container;
